export default __webpack_public_path__ + "static/media/workingWoman.4e671437.png";